(() => {
  if (window.KeshRugFeaturedCollections) return;

  const SELECTOR = '[data-kr-featured-carousel], [data-kr-featured-rail-root]';

  function initCarousel(root) {
    if (root.dataset.krReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-kr-slide]'));
    if (!slides.length) return;

    let index = Math.max(
      0,
      slides.findIndex((slide) => !slide.hidden)
    );
    let touchStartX = 0;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    root.addEventListener('click', (event) => {
      const previous = event.target.closest('[data-kr-previous]');
      const next = event.target.closest('[data-kr-next]');
      const swatch = event.target.closest('[data-kr-swatch]');

      if (previous) show(index - 1);
      if (next) show(index + 1);

      if (swatch) {
        const slide = swatch.closest('[data-kr-slide]');
        const image = slide?.querySelector('[data-kr-main-image]');
        const colour = slide?.querySelector('[data-kr-colour]');
        const imageUrl = swatch.dataset.krImage;
        const colourName = swatch.dataset.krColourName || '';

        slide?.querySelectorAll('[data-kr-swatch]').forEach((button) => {
          const isActive = button === swatch;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (image && imageUrl) {
          image.style.opacity = '0.18';
          window.setTimeout(() => {
            image.removeAttribute('srcset');
            image.src = imageUrl;
            image.alt = colourName
              ? `${image.dataset.krProductTitle} in ${colourName}`
              : image.dataset.krProductTitle;
            image.style.opacity = '1';
          }, 130);
        }

        if (colour && colourName) colour.textContent = `Shown in ${colourName.toLowerCase()}`;
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.target !== root) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    root.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      (event) => {
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) > 48) show(index + (distance < 0 ? 1 : -1));
      },
      { passive: true }
    );

    root.dataset.krReady = 'true';
    show(index);
  }

  function initRail(root) {
    if (root.dataset.krReady === 'true') return;

    const rail = root.querySelector('[data-kr-rail]');
    if (!rail) return;

    root.addEventListener('click', (event) => {
      const previous = event.target.closest('[data-kr-rail-previous]');
      const next = event.target.closest('[data-kr-rail-next]');
      if (!previous && !next) return;

      const direction = next ? 1 : -1;
      rail.scrollBy({
        left: direction * Math.min(rail.clientWidth * 0.82, 410),
        behavior: 'smooth',
      });
    });

    root.dataset.krReady = 'true';
  }

  function init(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.matches('[data-kr-featured-carousel]')) initCarousel(root);
      if (root.matches('[data-kr-featured-rail-root]')) initRail(root);
    });
  }

  window.KeshRugFeaturedCollections = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
